module.exports = __webpack_public_path__ + "static/media/exerciseIcon.af6eba28.svg";